<template>
    <div class='text-white flex justify-between items-center transition-all duration-500'
        v-if='!removed'
        :class='[isNav
            ? "h-[80px] w-full bg-coal px-2"
            : "bg-black w-[404px] px-4 py-6"
        , {
            "translate-x-[600px]": visable == false
        }]'
    >
        <div class='flex'>
            <IconPhone class='w-6 h-6 stroke-green-600 mr-2.5' v-if='isNav' />

            <div class=''>
                <p class='font-semibold text-15'>{{ call.name }}</p>
                <p class='text-14 text-grey-800'>{{ $help.e164ToNumber(call.from) }}</p>
                <p class='text-14 text-grey-700'>{{ call.status }}</p>
            </div>
        </div>

        <div class='flex items-center gap-2'>
            <template v-if='! call.answered && call.status != "Ended"'>
                <button class="call-btn-default bg-green-600" @click='$twilio.accept(call)'>
                    <IconPhone class="w-4.5 h-4.5 stroke-white" />
                </button>
                <button class="call-btn-default bg-red-700/80" @click="$twilio.end(call)">
                    <IconClose class="w-4.5 h-4.5 stroke-white" />
                </button>
            </template>

            <template v-if='call.answered && isNav'>
                <p class='pr-4 text-grey-800 text-15'>{{ $help.fmtMSS(call.duration) }}</p>

                <button class="call-btn-default bg-white/10 hover:bg-white/20" @click="$twilio.toggleMute(call)">
                    <component :is="call.muted ? 'IconMute' : 'IconVoiceSearch'" class="w-4 h-4 stroke-white" />
                </button>

                <button class="call-btn-default bg-white/10 hover:bg-white/20">
                    <IconUser class="w-5 h-5 stroke-white" />
                </button>

                <button class="call-btn-default bg-red-700/80 hover:bg-red-700" @click="$twilio.end(call)">
                    <IconDecline class="w-6 h-6 stroke-white" />
                </button>
            </template>
        </div>

        <div class="h-[5px] w-full bg-grey-800 absolute bottom-0 left-0 right-0" v-if="call.status == 'Ended'">
            <div class="h-[5px] bg-grey-900 toast-progress" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        call: Object,
        isNav: {
            type: Boolean, default: false
        }
    },

    data() {
        return {
            visable: true,
            removed: false
        }
    },

    created() {
        if (this.call.status == 'Ended') {
            this.visable = false;
            this.removed = true
        }
    },

    methods: {
        removeNotification() {
            setTimeout(() => {
                this.visable = false
                setTimeout(() => this.removed = true, 500)
            }, 7100)
        }
    },

    watch: {
        'call.status'(next, prev) {
            if (this.call.status == 'Ended') {
                this.removeNotification()
            }
        },
    },
}
</script>